<template>
    <perfect-scrollbar class="esesja-modal__wraper__body">
        <slot></slot>
    </perfect-scrollbar>
</template>
<script charset="utf-8">
    export default {
        name: "eSesjaModalBody"
    }
</script>